/**
 * API Key configuration utility
 * Stores all site API keys at module load for use anywhere.
 */

// Build the key map once at startup from env vars
const apiKeyMap = {
  ASU00002: process.env.VUE_APP_ASULINK_API_KEY_ASU02 || '',
  ASU00003: process.env.VUE_APP_ASULINK_API_KEY_ASU03 || '',
  ASU00004: process.env.VUE_APP_ASULINK_API_KEY_ASU04 || '',
  ASU00005: process.env.VUE_APP_ASULINK_API_KEY_ASU05 || '',
};

// Override with JSON env var if available
if (process.env.VUE_APP_ASULINK_API_KEYS) {
  try {
    Object.assign(apiKeyMap, JSON.parse(process.env.VUE_APP_ASULINK_API_KEYS));
  } catch {
    // ignore parse errors, individual env vars are already loaded
  }
}

const defaultKey = process.env.VUE_APP_ASULINK_API_KEY || '';

/**
 * Get API key for a specific site
 * @param {string} siteId - The site ID (e.g., 'ASU00002')
 * @returns {string} The API key for the site, or default key if not found
 */
export function getApiKey(siteId) {
  return apiKeyMap[siteId] || defaultKey;
}

/**
 * Get the full map of all stored API keys
 * @returns {Object} Map of site ID to API key
 */
export function getAllApiKeys() {
  return { ...apiKeyMap };
}

export default {
  getApiKey,
  getAllApiKeys,
};
